/**
 * 처리 모듈 3종. 키(cent · asm · stain)는 와이어프레임 실물과 맞물려 있어 그대로 둔다
 * (원본 HTML 은 데모 편의상 한 파일에 담고 `#surface=pad&mod=cent|asm|stain` 로 갈랐다.
 *  우리는 앱을 갈라 배포하므로 모듈마다 주소가 다르고, 각 앱은 루트 `/` 가 곧 모듈 화면이다).
 *
 * `product` 는 화면에 찍히는 제품명이다. 염색기는 `CTCells Stainer` 다(eric 2026-10-26 「Stainer 로 표기하도록 해」 —
 * 종전 `Liquid Handler` 는 폐기). 키 `stain` · 앱 디렉터리 `liquid-handler` · 한글 라벨 「염색기」는 그대로다.
 * `app` 은 이 모듈이 빌드되는 apps/ 디렉토리명이다(배포 단위 ↔ 모듈 키 대응표).
 *
 * ⚠ 한글 표기(「원심분리기」 등)는 여기 없다 — `@ctcells/i18n` 의 `module.<키>` 가 쥔다.
 *   제품명은 영문 고유명사라 번역 대상이 아니어서 이 표에 남는다(README §15).
 */
/**
 * 통합 콘솔의 제품명. 모듈 제품명과 같은 이유로 여기 있다 — 영문 고유명사라 번역 대상이 아니다.
 * 화면 표기 문구는 전부 `@ctcells/i18n` 이 쥐고, 제품명만 이 표에 남는다(README §15).
 */
export const CONSOLE_PRODUCT = 'CTCells Console'

export const MODULES = {
  cent: { product: 'CTCells Centrifuge', app: 'centrifuge' },
  asm: { product: 'CTCells Assembler', app: 'assembler' },
  stain: { product: 'CTCells Stainer', app: 'liquid-handler' },
} as const

export type ModuleKey = keyof typeof MODULES

export const MODULE_KEYS = Object.keys(MODULES) as ModuleKey[]

export function isModuleKey(value: string): value is ModuleKey {
  return value in MODULES
}
